import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import AuthReducer from './AuthReducer';
import ChildReducer from './ChildReducer';
import AddChildReducer from './AddChildReducer';
import ExpertQueryReducer from './ExpertQueryReducer';
import MetaDataReducer from './MetaDataReducer';
import RequestAppointmentReducer from './RequestAppointmentReducer';
import CustomFormReducer from './CustomFormReducer';
import VerifyOtpReducer from './VerifyOtpReducer';
import OrganizationReducer from './OrganizationReducer';
import CommunicationReducer from './CommunicationReducer'

export default combineReducers({
    auth: AuthReducer,
    child: ChildReducer,
    addChild: AddChildReducer,
    expertQuery: ExpertQueryReducer,
    metaData: MetaDataReducer,
    requestAppointment: RequestAppointmentReducer,
    customForm: CustomFormReducer,
    form: formReducer,
    verifyOtp: VerifyOtpReducer,
    organization: OrganizationReducer,
    communication: CommunicationReducer
});

export const persistentStoreBlacklist = [
    'auth',
    'child',
    'addChild',
    'expertQuery',
    'metaData',
    'requestAppointment',
    'customForm',
    'verifyOtp',
    'organization',
    'communication'
];